export default __webpack_public_path__ + "static/media/check-in-v2.8f184bd5.svg";